import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import { ConfigurationService } from 'Configuration/ConfigurationService';
import { FeatureFlag } from 'Environment/FeatureFlag';

export interface HTML5Configuration {
	supportsSessionReconnect: boolean;
	supportsInspectConnection: boolean;
	supportsHTML5InitialisedEvent: boolean;
	supportsHybridGacsForHTML5: boolean;
}

export class HTML5ConfigAccessor {
	private configurationService: ConfigurationService;

	public constructor(
		_workspaceConfiguration: WorkspaceConfiguration,
		configurationService: ConfigurationService
	) {
		this.configurationService = configurationService;
	}

	public getHTML5Configuration(): HTML5Configuration {
		return {
			supportsSessionReconnect:
				this.configurationService.featureCanaryConfiguration.isFeatureEnabled(
					FeatureFlag.EnableSessionReconnectForHTML5
				),
			supportsInspectConnection:
				this.configurationService.featureCanaryConfiguration.isFeatureEnabled(
					FeatureFlag.EnableInspectConnection
				) &&
				this.configurationService.featureCanaryConfiguration.isFeatureEnabled(
					FeatureFlag.EnableInspectConnectionForHTML5
				),
			supportsHTML5InitialisedEvent:
				this.configurationService.featureCanaryConfiguration.isFeatureEnabled(
					FeatureFlag.EnableHTML5InitialisedEvent
				),
			supportsHybridGacsForHTML5:
				this.configurationService.featureCanaryConfiguration.isFeatureEnabled(
					FeatureFlag.WSUIGACSHybridForHtml5
				),
		};
	}
}
